import { render, staticRenderFns } from "./modal-ativar-usuario.vue?vue&type=template&id=2eb27927"
import script from "./modal-ativar-usuario.vue?vue&type=script&lang=js"
export * from "./modal-ativar-usuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports